import validationSchema from '../pages/shipment/ShipmentForm.schema';
import _has from 'lodash/has';
import _set from 'lodash/set';
import _pick from 'lodash/pick';
import _get from 'lodash/get';
import { transform, isEqual, isObject } from 'lodash';
import _cloneDeep from 'lodash/cloneDeep';
import { FORMACTIONS, COUNTRY_US } from '../constants/constants';
const validateEverythingActions = [
  FORMACTIONS.TENDER,
  FORMACTIONS.MANUALLY_TENDER,
  FORMACTIONS.UPDATE
];
export const validateShipment = async (
  action,
  formValues,
  touched,
  isQuickRate = false
) => {
  const t = text => text;
  const shipment = _cloneDeep(formValues);
  const yupSchema = validationSchema({ t });
  let validationResults = null;

  try {
    await yupSchema
      .validate(shipment, {
        context: { formAction: action },
        abortEarly: false
      })
      .catch(function(err) {
        const errorObject = formatErrors(err.inner);
        return Promise.reject(errorObject);
      });
    return {};
  } catch (errors) {
    validationResults = errors;
  }

  let requiredToValidate = [];
  switch (action) {
    case FORMACTIONS.RATE:
      requiredToValidate = [
        'shipmentDirectionId',
        'shipmentModeId',
        'handlingUnits',
        'pickup.plannedToTimeLocal',
        'pickup.locationAddress.postalCode',
        'pickup.locationAddress.country',
        'delivery.locationAddress.postalCode',
        'delivery.locationAddress.country'
      ];
      if (isQuickRate) {
        if (
          _get(formValues, 'delivery.locationAddress.country') !== COUNTRY_US
        ) {
          requiredToValidate.push('delivery.locationAddress.city');
          requiredToValidate.push('delivery.locationAddress.state');
        }
        if (_get(formValues, 'pickup.locationAddress.country') !== COUNTRY_US) {
          requiredToValidate.push('pickup.locationAddress.city');
          requiredToValidate.push('pickup.locationAddress.state');
        }
      }
      break;
    case FORMACTIONS.DRAFT: {
      // if they touched a product or part of a unit , those become required
      // if they touched an pickup or a delivery they become required
      if (shipment.isLCPExceptionRequired) {
        requiredToValidate.push('lcpExceptionReasonId');
      }
      if (wasTouched(touched, 'pickup')) {
        requiredToValidate.push('pickup');
      }
      if (wasTouched(touched, 'delivery')) {
        requiredToValidate.push('delivery');
      }
      if (wasTouched(touched, 'handlingUnits')) {
        requiredToValidate.push('handlingUnits');
      }

      break;
    }
    default:
      requiredToValidate = [];
  }
  if (validateEverythingActions.includes(action)) {
    return validationResults;
  }
  const errorsLeft = _pick(validationResults, requiredToValidate);

  return errorsLeft;
};
export const wasTouched = (touched, path) => {
  const error = _get(touched, path, null);
  return error ? true : false;
};
export const formatErrors = errors => {
  const errorObject = {};
  errors.forEach(element => {
    const path = element.path;

    if (!_has(errorObject, path)) {
      _set(errorObject, path, element.message);
    }
  });

  return errorObject;
};

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export const difference = (object, base) => {
  return transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      result[key] =
        isObject(value) && isObject(base[key])
          ? difference(value, base[key])
          : value;
    }
  });
};
